import * as React from 'react';

import { connect, Dispatch } from 'react-redux';
import { ICalendarAppState } from '../redux-state';
import { closeFiltersDialog, closeMiniCalDialog } from '../redux-state/actions/calendar.actions';

interface StateToProps {
    filtersDialogOpen: boolean;
    miniCalDialogOpen: boolean;
}

interface DispatchToProps {
    closeFiltersDialog: () => void;
    closeMiniCalDialog: () => void;
}

export type ModalHelperProps = StateToProps & DispatchToProps;

/**
 * Utility class to bind the escape key to close modals.
 */
export class ModalHelperBase extends React.Component<ModalHelperProps> {
    constructor(props: ModalHelperProps) {
        super(props);

        this.bindEscKey = this.bindEscKey.bind(this);
        this.bindEscKey();
    }

    bindEscKey() {
        document.body.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.which === 27) {
                if (this.props.filtersDialogOpen) {
                    this.props.closeFiltersDialog();
                } else if (this.props.miniCalDialogOpen) {
                    this.props.closeMiniCalDialog();
                }
            }
        });
    }

    render() {
        return null;
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        filtersDialogOpen: state.calendar.filtersDialogOpen,
        miniCalDialogOpen: state.calendar.miniCalDialogOpen
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        closeFiltersDialog: () => { dispatch(closeFiltersDialog()); },
        closeMiniCalDialog: () => { dispatch(closeMiniCalDialog()); }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalHelperBase);
